import { IntegrationExportEntity } from "@nova/constants"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWRMutation from "swr/mutation"

interface AGOLExportRequest {
    workspaceId: string
    projectId: string
    entities: { type: IntegrationExportEntity; id: string }[]
    mergedFlightId?: string
}

const useExportToAGOL = () => {
    const { trigger: exportToAGOL, isMutating } = useSWRMutation(
        "agol-export",
        async (_key: string, { arg }: { arg: AGOLExportRequest }) => {
            const res = await fetchApiGateway("post /org/:orgId/integrations/agol/export", {
                params: { orgId: arg.workspaceId },
                body: {
                    projectId: arg.projectId,
                    entities: arg.entities,
                    mergedFlightId: arg.mergedFlightId,
                },
                rawResponse: true,
            })

            if (!res.ok) throw new Error("Unable to export to AGOL")
            return await res.json()
        }
    )

    return { exportToAGOL, isMutating }
}

export { useExportToAGOL }
export type { AGOLExportRequest }
